<template>
  <div class="info-box relative">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item
        label="车牌号"
        prop="number"
        :rules="[{ required: true, message: '请输入车牌号', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.number"></el-input>
      </el-form-item>

      <div class="grid grid-cols-3 gap-x-3">
        <el-form-item label="品牌型号">
          <!-- <template #label>
            <div class="float-right">
              <text>车型名称</text>
              <text class="text-orange-400 text-xs">
                车辆品牌+型号，如：奔驰E300L、宝马530Li
              </text>
            </div>
          </template> -->
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="类型"
          prop="d_car_type_id"
          :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]"
        >
          <el-select v-model="state.model.d_car_type_id">
            <el-option
              v-for="item in state.lx_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核载人数">
          <el-input-number
            v-model="state.model.passenger_capacity"
            precision="0"
            class="number-input-left number-input-suffix"
            suffix="人"
          ></el-input-number>
        </el-form-item>
      </div>
      <el-form-item label="服务时段">
        <el-date-picker
          v-model="state.model.service_times"
          type="daterange"
          range-separator="至"
          start-placeholder="服务时段"
          end-placeholder="服务时段"
          value-format="YYYY-MM-DD"
        />
      </el-form-item>
      <div class="grid gap-x-3" style="grid-template-columns: 1fr 2fr">
        <el-form-item
          label="司机姓名"
          prop="driver_name"
          :rules="[
            { required: true, message: '请输入司机姓名', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.driver_name"></el-input>
        </el-form-item>
        <el-form-item
          label="联系方式"
          prop="driver_phone"
          :rules="[
            { required: true, message: '请输入联系方式', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.driver_phone"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="所属公司">
        <el-select v-model="state.model.supplier_id">
          <template #label="{ value }">
            <div
              v-if="gys_map.get(value)"
              class="grid w-full gap-x-10 items-center"
              style="grid-template-columns: 1fr auto"
            >
              <text>{{ gys_map.get(value).name }}</text>
              <text class="text-gray-400 text-xs">
                {{ gys_map.get(value).number }}
              </text>
            </div>
          </template>
          <el-option
            v-for="item in state.gys_data"
            :key="item.id"
            :label="`${item.name} ${item.number} `"
            :value="item.id"
          >
            <div
              class="grid w-full gap-x-10 items-center"
              style="grid-template-columns: 1fr auto"
            >
              <text>{{ item.name }}</text>
              <text class="text-gray-400 text-xs">
                {{ item.number }}
              </text>
            </div>
          </el-option>
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadGys()"
            >
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="说明">
        <el-input
          v-model="state.model.intro"
          type="textarea"
          :autosize="{ minRows: 2 }"
          placeholder="请填写计费说明"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from "vue";
import {
  meeting_car_detail,
  meeting_car_add,
  meeting_car_edit,
} from "@/http/meeting";
import { dic_getCarType, data_getSupplier } from "@/http/data";
import { post_response } from "@/utils/funcs";
import { dayjs } from "element-plus";

export default {
  props: {
    meeting_id: Number,
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        meeting_id: props.meeting_id,
      },
    });

    onMounted(() => {
      onLoadLx();
      onLoadGys();
      if (props.id) {
        meeting_car_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.service_times = [
              dayjs(data.service_time_start).format("YYYY-MM-DD"),
              dayjs(data.service_time_end).format("YYYY-MM-DD"),
            ];
          }
        });
      }
    });

    //获取车辆类型
    const onLoadLx = () => {
      dic_getCarType().then((res) => {
        if (res.status == 200) {
          state.lx_data = res.data?.data || [];
        }
      });
    };

    //获取供应商
    const onLoadGys = () => {
      data_getSupplier().then((res) => {
        if (res.status == 200) {
          state.gys_data = res.data?.data?.list || [];
        }
      });
    };

    /**
     * 把供应商数组重组成map对象，原数组更新时map对象自动更新
     * 例：原数组   state.gys_data = [{id:101,name:"供应商A"},{id:102,name:"供应商B"}]
     * 例：map对象则为   gys_map = Map {101 => {id:101,name:"供应商A"}, 102 => {id:102,name:"供应商B"}}
     * 页面中若通过find查询的话，则每次都需要循环数组，效率低，而通过map对象查询则直接返回对象，效率高，
     */
    const gys_map = computed(() => {
      const m = new Map();
      state.gys_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.model.service_times?.length == 2) {
            state.model.service_time_start =
              state.model.service_times[0] + " 00:00:00";
            state.model.service_time_end =
              state.model.service_times[1] + " 23:59:59";
          }
          if (props.id) {
            meeting_car_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            meeting_car_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      gys_map,
      onLoadLx,
      onLoadGys,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
